import classNames from 'classnames'

export interface TitleProps extends React.ComponentPropsWithoutRef<'h3'> {}

export const Title = ({ children, className, ...props }: TitleProps) => {
  return (
    <h3
      className={classNames('content-teaser-group__title', className)}
      {...props}
    >
      {children}
    </h3>
  )
}
